import PropTypes from 'prop-types';
import styled from 'helpers/styles';
import ComponentStyles from 'styles/mixins/Component.styles';
import CardActions from '@mui/material/CardActions';

const StyledCardActions = styled(CardActions)` 
  ${ComponentStyles}
`;

StyledCardActions.propTypes = {
  theme: PropTypes.object
};

export default StyledCardActions;
